import React, { useMemo } from "react";
import * as THREE from "three";

const Triangle = ({ vertices }) => {
  const f32array = useMemo(
    () =>
      Float32Array.from(
        new Array(vertices.length)
          .fill()
          .flatMap((item, index) => vertices[index])
      ),
    [vertices]
  );

  return (
    <mesh position={[0, 0, 0]}>
      <bufferGeometry attach="geometry">
        <bufferAttribute
          attach="attributes-position"
          // attachObject={["attributes", "position"]}
          args={[f32array, 3]}
        />
      </bufferGeometry>
      <meshBasicMaterial
        attach="material"
        color="#000000"
        wireframe={false}
        side={THREE.DoubleSide}
      />
    </mesh>
  );
};

export default Triangle;
